import React, { useContext, useEffect } from 'react'
import { Head } from '@notino/react-toolkit/exports/Head'
import { useIntl } from 'react-intl'

// utils
import { DEFAULT_LOCALE, getEnvironmentAndLocaleSpecificShopsConfig, getEnvironmentSpecificShopsConfig } from '../../../../appDefaults'
import { PAGE_LINKS } from '../../../../utils/helper'
import { AppContext } from '../../../../utils/appProvider'

// types
import { CmsHomeMetadata } from '../../../../types/types'

type Props = {
	metaData: CmsHomeMetadata
}

const HomepageHead = (props: Props) => {
	const { locale } = useIntl()
	const { metaData } = props
	const { productionEnvironment } = useContext(AppContext)
	const defaultShop = getEnvironmentAndLocaleSpecificShopsConfig(productionEnvironment, DEFAULT_LOCALE)
	const currentShop = getEnvironmentAndLocaleSpecificShopsConfig(productionEnvironment, locale)
	const shops = getEnvironmentSpecificShopsConfig(productionEnvironment)

	const currentPath = `${currentShop.url}${PAGE_LINKS['/salons'](currentShop.locale)}`

	useEffect(() => {
		document.title = metaData.metaTitle
	}, [metaData.metaTitle])

	// canonical href
	const canonicalHref = currentPath

	// alternate hrefs
	const alternateLinks = shops
		.map((shop) => {
			return {
				href: `${shop.url}${PAGE_LINKS['/salons'](shop.locale)}`,
				lang: shop.lang
			}
		})
		.filter(Boolean)

	// x-default href
	const xDefaultHref = `${defaultShop.url}${PAGE_LINKS['/salons'](defaultShop.locale)}`
	// NOTE: defining children as array and using .flat() on it otherwise <Head> doesn't work properly
	// each item has to have unique 'key' because <Head/> iterates over the array
	const children = [
		// charset
		<meta key='charset' charSet='utf-8' />,

		// title
		<title key='title'>{metaData.metaTitle}</title>,

		// description
		<meta key='description' name='description' content={metaData.metaDescription} />,

		// keywords
		<meta key='keywords' name='keywords' content={metaData.metaKeywords} />,

		// canonical
		<link key='canonical' rel='canonical' href={canonicalHref} />,
		// alternates
		alternateLinks.map((link, id) => {
			return <link key={`alternate-${id}`} rel='alternate' href={link.href} hrefLang={link.lang} />
		}),
		// x-default
		<link key='x-default' rel='alternate' href={xDefaultHref} hrefLang='x-default' />
	]
		.flat()
		.filter(Boolean)

	return <Head>{children}</Head>
}

export default HomepageHead
